import { ReactElement, useEffect, useState } from "react";
import { IDelayQMOS } from "../../../../types";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputAdornment from "@mui/material/InputAdornment";
import { formatTimeWithSeconds } from "../../../../system/utils";

interface IDelayDialog {
  open: boolean;
  handleClose: any;
  selectedNewRow: IDelayQMOS;
  handleAccept?: any;
}

const layout = {
  marginTop: "1em",
  display: "grid",
  height: "115px",
  gridTemplateColumns: "auto auto auto 100px",
  // gridTemplateRows: "35px 35px 35px",
  gridTemplateRows: "1px 55px 55px",
  justifyContent: "start",
  // background: "Green"
};

const textOrginBeginStyle = {
  gridColumn: "2 / span 1",
  gridRow: "2 / span 1",
  // background: "#C0C0C0",
  margin: "0em 0.1em 0em 0.3em"
};

const textOrginEndStyle = {
  gridColumn: "3 / span 1",
  gridRow: "2 / span 1",
  // background: "#ABCDEE",
  margin: "0em 0.1em 0em 0.3em"
};

const textDurationStyle = {
  gridColumn: "4 / span 1",
  gridRow: "2 / span 1",
  // background: "#FEFEFE",
  margin: "0em 0.1em 0em 0.3em"
};

const textNewBeginStyle = {
  gridColumn: "2 / span 1",
  gridRow: "3 / span 1",
  // background: "#ABCFED",
  margin: "0em 0.1em 0em 0.3em"
};

const textNewEndStyle = {
  gridColumn: "3 / span 1",
  gridRow: "3 / span 1",
  // background: "Cyan",
  margin: "0em 0.1em 0em 0.3em"
};

const text34 = {
  gridColumn: "4 / span 1",
  gridRow: "3 / span 1",
  // background: "pink",
  margin: "0em 0.1em 0em 0.3em"
};

const CutDelayDialog = ({ open, handleClose, selectedNewRow, handleAccept }: IDelayDialog): ReactElement => {
  const [duration, setDuration] = useState<number>(0);
  const [maxDuration, setMaxDuration] = useState<number>(0);

  useEffect(() => {

    if (selectedNewRow) {

      const totalDuration = (selectedNewRow.endDatetime ? selectedNewRow.endDatetime : 0) - selectedNewRow.beginDatetime;
      setMaxDuration(totalDuration);


      const initialDuration = Math.round(totalDuration / 2);
      setDuration(initialDuration);
      //  setDuration(0);
    }
  }, [selectedNewRow]);


  const onHandleAccept = () => {

    if (!selectedNewRow.production) {
      return;
    }

    if(selectedNewRow) {
      const a1 = (selectedNewRow.endDatetime ? selectedNewRow.endDatetime : 0) * 1000;
      const a2 = (selectedNewRow.beginDatetime + duration) * 1000;

      if(a1 === a2) {
        alert("Error: The original end time is the same that new end time!!!!");

        return;
      }

      handleAccept(selectedNewRow.production.productionID, selectedNewRow.production.machine.machineID, a2, a1, selectedNewRow.delayID);
    }
  };

  const onSetDuration = (durationTime: number) =>{
    if(durationTime > maxDuration) {
      return;
    }

    setDuration(durationTime);

  };

  return (
    <div>
      <Dialog maxWidth={"md"} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Modify Delay</DialogTitle>
        <DialogContent dividers={true}>

          <div style={layout}>

            <div style={textOrginBeginStyle}>

              <TextField
                variant="standard"
                disabled={true}
                label="Original Begin"
                fullWidth = {true}
                value = {formatTimeWithSeconds(selectedNewRow.beginDatetime)}
                slotProps={{
                  input: {
                  readOnly: true,
                }}}
              />

            </div>

            <div style={textOrginEndStyle}>

              <TextField
                variant="standard"
                disabled={true}
                label="Original End"
                fullWidth = {true}
                value = {formatTimeWithSeconds(selectedNewRow.beginDatetime + duration)}
                slotProps={{
                  input: {
                  readOnly: true,
                }}}
              />

            </div>

            <div style={textDurationStyle}>
              <TextField
                variant="standard"
                label="Duration"
                fullWidth={true}
                type="number"
                value={duration}
                onChange={e=> onSetDuration(Number(e.target.value)) }
                slotProps={{
                  inputLabel: {
                    shrink: true
                  },
                  input: {
                    // startAdornment: <InputAdornment position="start">s</InputAdornment>,
                  endAdornment: <InputAdornment position="end">s</InputAdornment>,
                  inputProps: {
                    max:{ maxDuration },
                    min: 0
                  }
                }}}
              />

            </div>


            <div style={textNewBeginStyle}>

              <TextField
                variant="standard"
                disabled={true}
                label="New Begin"
                fullWidth = {true}
                value = {formatTimeWithSeconds(selectedNewRow.beginDatetime + duration)}
                slotProps={{
                  input: {
                  readOnly: true,
                }}}
              />
            </div>

            <div style={textNewEndStyle}>

              <TextField
                variant="standard"
                disabled={true}
                label="Original End"
                fullWidth = {true}
                value = {formatTimeWithSeconds(selectedNewRow.endDatetime)}
                slotProps={{
                  input: {
                  readOnly: true,
                }}}
              />
            </div>

            <div style={text34}/>
          </div>

        </DialogContent>
        <DialogActions>
          {selectedNewRow.production &&
            <Button onClick={onHandleAccept} color="primary" variant="contained" >
              Accept
            </Button>
          }
          <Button onClick={handleClose} color="secondary" variant="contained" >
                        Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CutDelayDialog;
